import {Box, Checkbox, Grid, IconButton, List, ListItem, ListItemText, Tooltip} from "@mui/material";
import React, {useState} from "react";
import {Info, KeyboardArrowDownOutlined, KeyboardArrowUpOutlined} from "@mui/icons-material";
import {formatDate} from "../../Utils/dateUtils";
import {ADD, COMPLETED, FOLLOW_UP} from "../../Utils/constants";
import {
    TodoActionCheckbox,
    TodoActionHistoryNoteTextInput,
    TodoActionMultiRadioGroup,
    TodoActionPhoneMeeting,
    TodoActionShowText,
    TodoActionSingleRadioGroup
} from "../EventsOverview/Tabs/TodoOverviewTab";
import {toast} from "react-toastify";
import AddOpportunityActionModal from "../Calendar/Widgets/CalendarWidget/AddOpportunityActionModal";
import {selectors as accountSelectors} from '../../../Ducks/account';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {useNavigate} from "react-router-dom";

function PersonTodoList(props) {
    const {
        user,
        todos,
        type,
        markDoneCallback,
        person,
        jobEmail
    } = props;
    const [checkedTodos, setCheckedTodos] = useState([]);
    const [openAddEventModal, setOpenAddEventModal] = useState(false);
    const [todoFollowUp, setTodoFollowUp] = useState(null);
    const [checkShowDescriptionTodo, setCheckShowDescriptionTodo] = useState([]);

    const isOpen = (todo) => {
        return checkedTodos?.find((item) => item.id === todo.id)?.checked;
    }

    const renderTodoListItemComponent = (todo) => {

        return (
            <ListItem
                key={todo.id}
                sx={{
                    width: '100%',
                    margin: '8px 0',
                    padding: 0,
                    borderRadius: '4px',
                    backgroundColor: isCompleted(todo) ? '#f5f5f5' : 'white',
                }}>
                <Grid container>
                    <Grid item xs={9}>
                        <Box display='flex' justifyContent='left'>
                            <Box
                                sx={{
                                    width: '5px',
                                    height: '9hvp',
                                    backgroundColor: `${todo.kpi_criteria?.color_code}`,
                                    borderRadius: '4px 0 0 4px', // Rounds left edges of the bar
                                }}
                            />
                            <Checkbox
                                edge="end"
                                checked={isCompleted(todo) || checkShowDescriptionTodo?.id === todo.id}
                                disabled={type === 'history' || isCompleted(todo) || !canUserMarkDone(todo)}
                                onClick={(e) => handleTodoCheckboxChanged(e, todo)}
                            />
                            <ListItemText
                                primary={
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%'
                                        }} onClick={() => handleTodoClick(todo)}>{todo.title}
                                    </Box>
                                }
                                secondary={`Associated KPIs: ${todo.kpi_title} - ${todo.kpi_criteria?.title}`}
                                sx={{
                                    marginLeft: 2, // Add spacing after color bar
                                    marginTop: '15px',
                                    textDecoration: isCompleted(todo) ? 'line-through' : 'none',
                                    color: isCompleted(todo) ? 'gray' : 'inherit',
                                }}
                            >
                            </ListItemText>
                        </Box>
                        {
                            checkedTodos?.find((item) => item.id === todo.id)?.checked && todo.actions?.map((action) => (
                                    <Grid container justifyContent='left' padding='10'>
                                        {renderActionComponent(action, todo)}
                                    </Grid>
                                )
                            )
                        }
                    </Grid>
                    <Grid item xs={3} sx={{
                        margin: '1em 0em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'right',
                        paddingRight: '1em',
                        width: '100%'
                    }}>

                        {isOpen(todo) ? <KeyboardArrowDownOutlined onClick={() => handleTodoClick(todo)}/> :
                            <KeyboardArrowUpOutlined onClick={() => handleTodoClick(todo)}/>}
                        <Tooltip title={todo.description} arrow
                                 position='top'>
                            <IconButton size="small" sx={{marginLeft: 1}}>
                                <Info fontSize="small" color="action"/>
                            </IconButton>
                        </Tooltip>
                        {formatDate(todo.due_date)}
                    </Grid>
                </Grid>
            </ListItem>
        )
    };

    const renderActionComponent = (action, todo) => {
        switch (action.type) {
            case 'history_note':
                return <TodoActionHistoryNoteTextInput participantTodoId={todo.id} action={action}
                                                       readOnly={type === 'history' || !canUserMarkDone(todo) ? true : false}
                                                       handleHistoryNoteTextInputCallback={handleHistoryNoteTextInputCallback}/>;
            case 'single_radio':
                return <TodoActionSingleRadioGroup participantTodoId={todo.id} action={action}
                                                   readOnly={type === 'history' || !canUserMarkDone(todo) ? true : false}
                                                   handleSingleRadioClickCallback={handleSingleRadioClickCallback}/>;
            case 'multi_radio':
                return <TodoActionMultiRadioGroup participantTodoId={todo.id} action={action}
                                                  readOnly={type === 'history' || !canUserMarkDone(todo) ? true : false}
                                                  handleMultiRadioClickCallback={handleMultiRadioClickCallback}/>;
            case 'text_only':
                return <TodoActionShowText todo={todo} action={action}/>
            case 'checkbox':
                return <TodoActionCheckbox participantTodoId={todo.id} action={action}
                                           readOnly={type === 'history' || !canUserMarkDone(todo) ? true : false}
                                           handleCheckboxChangeCallback={handleCheckboxChangeCallback}/>
            case 'follow_up':
                return <TodoActionPhoneMeeting todo={todo} action={action}
                                               readOnly={type === 'history' || !canUserMarkDone(todo) ? true : false}
                                               handlePhoneMeetingClickCallback={handlePhoneMeetingClickCallback}/>
        }
    }

    const handleTodoClick = (todo) => {
        let checkedTodo = checkedTodos.find((item) => (item.id === todo.id));

        if (checkedTodo) {
            setCheckedTodos((prevTodos) => prevTodos.map((item) =>
                item.id === todo.id ? {...item, checked: !item.checked} : item
            ))
        } else {
            setCheckedTodos((prevTodos) => [...prevTodos, {id: todo.id, checked: true}]);
        }
    }

    const isCompleted = (todo) => {
        return (todo.status === COMPLETED)
    }

    const handleTodoCheckboxChanged = (e, todo) => {
        const {checked} = e.target;
        const showDescription = todo?.actions.filter((item) => item.type === 'text_only');

        if (checked && showDescription?.length > 0 && handleShowDescriptionCallback) {
            setCheckShowDescriptionTodo(todo);
            handleShowDescriptionCallback(todo.id, showDescription[0], todo.description);
        }
    }

    const canUserMarkDone = (todo) => {
        if (user.user_details.user_id == todo.user_id) {
            return true;
        }
        return false;
    };

    const handleHistoryNoteTextInputCallback = (participantTodoId, action, text) => {
        if (text?.length) {
            let payload = {
                'type': action.type,
                'action_id': action.id,
                'response': text,
            }

            markDone(participantTodoId, payload);
        }
    }

    const handleSingleRadioClickCallback = (participantTodoId, action, responseYesOrNo) => {
        if (responseYesOrNo?.length) {
            let payload = {
                'type': action.type,
                'action_id': action.id,
                'response': responseYesOrNo,
            }

            markDone(participantTodoId, payload);
        }
    }

    const handleMultiRadioClickCallback = (participantTodoId, action, selected) => {
        if (selected?.length) {
            let payload = {
                'type': action.type,
                'action_id': action.id,
                'response': selected
            }

            markDone(participantTodoId, payload);
        }
    }

    const handleShowDescriptionCallback = (participantTodoId, action, text) => {
        if (text?.length) {
            let payload = {
                'type': action.type,
                'action_id': action.id,
                'response': text
            }
            markDone(participantTodoId, payload);
        }
    }

    const handleCheckboxChangeCallback = (participantTodoId, action, selected) => {
        if (selected?.length) {
            let payload = {
                'type': action.type,
                'action_id': action.id,
                'response': selected
            }

            markDone(participantTodoId, payload);
        }
    }

    const handlePhoneMeetingClickCallback = (todo) => {
        if (person !== undefined || jobEmail !== null) {
            setOpenAddEventModal(true);
            setTodoFollowUp(todo);
        } else {
            if (todo.job_email !== null && todo.job_email != undefined) {
                jobEmail = todo.job_email
            } else {
                toast.error('Person does not have job email');
            }
        }
    }

    const handleFollowUpCallback = (FollowUpDate) => {
        if (todoFollowUp) {
            const followUp = todoFollowUp?.actions.find((item) => item.type === FOLLOW_UP);

            let payload = {
                'type': followUp.type,
                'action_id': followUp.id,
                'response': FollowUpDate
            }

            markDone(todoFollowUp.id, payload);
        }
    }

    const markDone = (participantTodoId, payload) => {
        markDoneCallback(participantTodoId, payload);
    }

    const handleAddEventModalClose = (_formSubmitted = false) => {
        setOpenAddEventModal(false);
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <>
                        <List sx={{width: '100%'}}>
                            {
                                todos?.map((item) => (
                                    <>
                                        {
                                            renderTodoListItemComponent(item)
                                        }
                                    </>
                                ))
                            }
                        </List>
                    </>
                </Grid>
            </Grid>
            <AddOpportunityActionModal open={openAddEventModal} handleClose={handleAddEventModalClose}
                                       jobEmail={jobEmail} person={person} mode={ADD} actionType={FOLLOW_UP}
                                       handleTodoFollowUpCallback={handleFollowUpCallback}
            />
        </>

    )
};
const mapStateToProps = (state) => ({
    user: accountSelectors.user(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {},
    dispatch);

function WithNavigate(props) {
    let navigate = useNavigate();
    return <PersonTodoList {...props} navigate={navigate}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);